<section class="titulo">
    <p>
        <br><br>
    </p>
    <div class="titleImagen">
        <p style="line-height: 100%;" class="fontMS700 colorPrincipal font-45 mb-0">
            JOSÉ BERNARDO ALZEDO: <br>
            
        </p>
        <p class="fontMS500 colorPrincipal font-45">FILOSOFÍA DE LA MÚSICA </p>
        <div id="sharePic">
            <a (click)="test.toggle()" mdbWavesEffect>
                <img width="200px" src="/assets/images/general/MP_BOTON_COMPARTIR.jpg">
            </a>
            <div mdbCollapse #test="bs-collapse">
                <div class="divShared">
                    &nbsp;
                    &nbsp;
                    <a target="_blank"
                        href="http://www.facebook.com/sharer.php?u=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio37/bernardo-alzedo">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_FB.png">
                    </a>&nbsp;
                    <a target="_blank"
                        href="https://api.whatsapp.com/send?text=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio37/bernardo-alzedo">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_INST.png">
                    </a>&nbsp;
                    <a target="_blank"
                        href="https://twitter.com/intent/tweet?text=MemoriaPeru&url=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio37/bernardo-alzedo">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_TW.png">
                    </a>
                </div>
            </div>
        </div>
    </div>
    <img class="img_portada" src="/assets/images/micrositio/micrositio37/BERNARDO-001.png">
</section>

<div class="fondoBlanco_Intro mt-1">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <p class="fontMS500 text-center font-24">
                    <br><br>
                    JOSÉ BERNARDO ALZEDO (1788-1878) NO SOLO ES EL COMPOSITOR DEL HIMNO NACIONAL DEL PERÚ. ES 
                    TAMBIÉN UNA DE LAS FIGURAS CLAVES DE LA MÚSICA PERUANA Y LATINOAMERICANA DEL SIGLO XIX. 
                    COMO SEÑALA JOSÉ MANUEL IZQUIERDO, UNO DE LOS MÁS DESTACADOS INVESTIGADORES DE SU OBRA, 
                    ALZEDO «ES UN MÚSICO EN TRÁNSITO ENTRE LA COLONIA Y LA REPÚBLICA, QUE DEJÓ UN LEGADO 
                    MUSICAL E INTELECTUAL DE ENORME RELEVANCIA, DESDE SUS OBRAS RELIGIOSAS A SU MONUMENTAL 
                    FILOSOFÍA DE LA MÚSICA. DESCUBRIR A ESE ALZEDO, CANTOR PATRIÓTICO Y MÚSICO INTEGRAL, ES UNA 
                    TAREA PENDIENTE. (…) EN EL CASO DE ALZEDO, ESTO ES ESPECIALMENTE EVIDENTE, DAD[A]S SUS 
                    MÚLTIPLES TRANSICIONES: MÚSICO ENTRE COLONIAL Y REPÚBLICA, MULATO, ENTRE PERÚ Y CHILE, ENTRE 
                    LO RELIGIOSO Y LO PATRIÓTICO, ENTRE EL SIGLO XVIII Y EL XIX, ENTRE EL ESTILO CLÁSICO Y EL ROMÁNTICO».
                    <br>
                </p>
                <div class="row p-5">
                    <div class="col-sm-1"></div>
                    <div class="col-sm-10" >
                        <br><br><br>
                        <div class="col-sm-12" >
                            <a href="http://hdl.handle.net/20.500.14428/81132" target="_blank" style="color: #80257d;" >
                                <img width="100%" src="/assets/images/micrositio/micrositio37/BERNARDO-041.png">
                            
                            
                                <p class="text-center text-white font-12" style="background: #80257d" >
                                    <br><br>
                                    Partituras de José Bernardo Alzedo. Imagen publicada en: Concierto de gala de musica patriotica de José Bernardo Alzeda:<br>
                                    colección de la Biblioteca Nacional del Perú. Segunda edición. Lima: Biblioteca Nacional del Perú, 2016.-p.[12].9.8 x 19cm <br>
                                    <br><br>
                                </p>
                            </a>
                        </div>
                    </div>
                    
                    <div class="col-sm-1"></div>
                </div>
                <p class="fontMS300 text-center font-24">
                    LA BIBLIOTECA NACIONAL DEL PERÚ (BNP) POSEE LA MÁS IMPORTANTE COLECCIÓN DE PARTITURAS
                    MUSICALES DEL AUTOR DE NUESTRO HIMNO NACIONAL, VENDIDA POR CIRO ÑAPANGA, PROMOTOR DE
                    LAS BIBLIOTECAS ESCOLARES, Y RODOLFO HOLZMANN. ACTUALMENTE DICHA COLECCIÓN, DENOMINADA
                    COLECCIÓN “JOSÉ BERNARDO ALZEDO”, SE ENCUENTRA DEBIDAMENTE INVENTARIADA Y CATALOGADA
                    PARA EL USO DE LOS INVESTIGADORES. DEL MISMO MODO, EN LOS ÚLTIMOS AÑOS, LA BNP ORGANIZÓ LA
                    REALIZACIÓN DE CONCIERTOS DE MÚSICA A PARTIR DE OBRAS MUSICALES DE ALZEDO EN LIMA, TRUJILLO,
                    ABANCAY, AYACUCHO, AREQUIPA Y CUSCO.
                    <br><br>
                </p>
                <p class="fontMS100 text-center font-20">
                    EN EL MARCO DE LA CONMEMORACIÓN DEL BICENTENARIO DEL PROCESO DE EMANCIPACIÓN PERUANA, SE OFRECE ESTE MICROSITIO DESTINADO A
                    (RE)VALORAR LA OBRA DE JOSÉ BERNARDO ALZEDO, OFRECER NUEVAS LECTURAS A LOS MUSICÓLOGOS, INTÉRPRETES Y GESTORES MUSICALES Y,
                    FUNDAMENTALMENTE, PONER EN VALOR ESTAS PARTITURAS QUE CONSTITUYEN PARTE IMPORTANTE DEL IMAGINARIO NACIONAL.
                    <br><br>
                </p>
            </div>
        </div>
    </div>
</div>

<div class="fondoNegro">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <!-- <div class="col-sm-1"></div> -->
                    <div class="col-sm-3 bott">
                        <img class="LineSubsec_Izq bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio37/BERNARDO-LINEA-001.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel" style="margin-bottom: 2%;" width="100%"
                            src="/assets/images/micrositio/micrositio37/BERNARDO-LINEA-001.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 150%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal  font-40">
                            ASPECTOS BIOGRÁFICOS
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec_Izq bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio37/BERNARDO-LINEA-001.png">
                    </div>
                    <!-- <div class="col-sm-1"></div> -->
                    <div class="c100">
                        <img class="lineCel" style="margin-top: 2%;" width="100%"
                            src="/assets/images/micrositio/micrositio37/BERNARDO-LINEA-001.png">
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <p class="fontMS100 text-justify text-white font-22">
                            <br><br>
                            LA FIGURA MÁS IMPORTANTE DE LA MÚSICA EN EL PERÚ DEL SIGLO XIX NACIÓ EN LIMA, EL 20 DE AGOSTO DE 1788.
                            <br><br>
                            INICIÓ SUS ESTUDIOS MUSICALES EN EL CONVENTO DE SAN AGUSTÍN; POSTERIORMENTE EN LA IGLESIA DE SANTO
                            DOMINGO, DIRIGIDA POR EL FAMOSO MÚSICO FRAY PASCUAL NIEVES. ASIMISMO, HIZO LOS VOTOS SIMPLES DE
                            HERMANO TERCIARIO DOMINICO.
                            <br><br>
                            A LOS 18 AÑOS YA HABÍA COMPUESTO UNA MISA EN RE MAYOR Y ALGUNAS OTRAS OBRAS RELIGIOSAS. COMPUSO
                            TAMBIÉN PIEZAS POPULARES Y DE CARÁCTER PATRIÓTICO.
                            <br><br>
                            EN 1821, CONVERTIDO EN EL AUTOR DEL HIMNO NACIONAL Y ANTE LA IMPOSIBILIDAD DE SER SACERDOTE,
                            ABANDONA EL CONVENTO. POCO DESPUÉS, SE INCORPORA AL BATALLÓN N° 4 DE CHILE COMO “MÚSICO MAYOR”.
                            <br><br>
                        </p>
                    </div>
                    <div class="col-sm-1"></div>
                    <div class="col-sm-5">
                        <p class="fontMS100 text-justify text-white font-22">
                            <br><br>
                            EN SANTIAGO DE CHILE, ALZEDO CULMINA SU
                            CARRERA MILITAR, Y ALLÍ REINICIA LA
                            COMPOSICIÓN DE OBRAS RELIGIOSAS.
                            ASIMISMO, SE DEDICÓ A LA ENSEÑANZA
                            PARTICULAR SIENDO PROFESOR EN CENTROS
                            EDUCATIVOS Y MAESTRO EN CONVENTOS Y
                            BANDAS MILITARES.
                            <br><br>
                            EN 1847, FUE NOMBRADO MAESTRO DE CAPILLA
                            DE LA CATEDRA DE SANTIAGO. SU PERMANENCIA
                            EN ESE PAÍS SE EXTENDIÓ DESDE 1823 A 1864,
                            INTERRUMPIDA POR DOS VIAJES A LIMA. EN ESE
                            LAPSO COMPONE MUCHAS OBRAS
                            ECLESIÁSTICAS Y ALGUNAS DE CARÁCTER
                            PATRIÓTICO.
                            <br><br>
                            VUELVE AL PERÚ DEFINITIVAMENTE A LOS 76
                            AÑOS. SE LE RECIBE CON HONORES PERO MUERE
                            SOLO Y EN LA POBREZA.
                            <br><br>
                        </p>
                    </div>
                    <div class="col-sm-1"></div>
                    <div class="col-sm-5">
                        <a href="https://hdl.handle.net/20.500.14428/65341" target="_blank" >
                            <img width="100%" src="/assets/images/micrositio/micrositio37/BERNARDO-003.png">
                        </a>
                        
                                <p class="text-center text-white font-12" style="background: #80257d" >
                                    <br><br>
                                    Reproducción fotográfica de José Bernardo Alzedo Retuerto. [Lima, 1869].<br>
                                    1 negativo sobre placa de vidrio: gelatino bromuro. 18 x 13 cm.<br>
                                    <br>
                                    Disponible en<a href="https://hdl.handle.net/20.500.14428/65341" target="_blank" style="color: #ffffff;" >
                                    Biblioteca Digital<br>
                                    <br><br>
                                    </a>
                                </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoBlanco">
    <div class="container">
        <div class="row mt-5">
            <div class="col-sm-3">
                <a href="http://hdl.handle.net/20.500.14428/79776" target="_blank">
                    <img width="100%" src="/assets/images/micrositio/micrositio37/BERNARDO-004.png">
                </a>
                    <p class="fontMS100Italic text-center text-white font-12" style="background: #424342; padding-left: 5%; padding-right: 5%" >
                            <br><br>
                            Carta de José Bernardo Alzedo a Juan D.<br>
                            Rivera. Santiago de Chile, 8 de junio de 1863.
                            Pág. 248.<br>
                            <br>
                        Disponible en: <a href="http://hdl.handle.net/20.500.14428/79776" target="_blank" style="color: #ffffff;" >
                        Biblioteca Digital<br>
                            <br><br><br><br>
                        </a>
                    </p>
            </div>
            <div class="col-sm-3">
                <a href="http://hdl.handle.net/20.500.14428/80520" target="_blank">
                    <img width="100%" src="/assets/images/micrositio/micrositio37/BERNARDO-005.png">
                </a>
                    <p class="fontMS100Italic text-center text-white font-12" style="background: #424342 ; padding-left: 5%; padding-right: 5%" >
                            <br><br>
                            Retrato de Juana Rojas y Cea de Alzedo, esposa de
                            José Bernardo Alzedo, por el pintor peruano Juan
                            Guillermo Samanez. Reproducido en: Historia
                            crítica del Himno Nacional. Pág. 67.<br>
                            <br>
                        Disponible en: <a href="http://hdl.handle.net/20.500.14428/80520" target="_blank" style="color: #ffffff;" >
                        Biblioteca Digital<br>
                            <br><br>
                        </a>
                    </p>
            </div>
            <div class="col-sm-3">
                <a href="http://hdl.handle.net/20.500.14428/81132" target="_blank" >
                    <img width="100%" src="/assets/images/micrositio/micrositio37/BERNARDO-006.png">
                </a>
                    <p class="fontMS100Italic text-center text-white font-11" style="background: #424342 ; padding-left: 5%; padding-right: 5%" >
                            <br><br>
                            Retrato de José Bernardo Alzedo. Imagen
                            publicada en El Mercurio (Santiago de Chile) y
                            reproducida en: Concierto de gala de música
                            patriótica de José Bernardo Alzedo : colección de la
                            Biblioteca Nacional del Perú. Cuarta edición. Lima:
                            Biblioteca Nacional del Perú, 2015. Pág. 9.<br>
                            <br>
                        Disponible en: <a href="http://hdl.handle.net/20.500.14428/81132" target="_blank" style="color: #ffffff;" >
                        Biblioteca Digital<br>
                            <br>
                        </a>
                    </p>
            </div>
            <div class="col-sm-3">
                <a href="http://hdl.handle.net/20.500.14428/80520" target="_blank">
                    <img width="100%" src="/assets/images/micrositio/micrositio37/BERNARDO-007.png">
                </a>
                    <p class="fontMS100Italic text-center text-white font-12" style="background: #424342; padding-left: 5%; padding-right: 5%" >
                            <br><br>
                            Imagen de la antigua Iglesia de San Carlos, hoy
                            Panteón de los Próceres, lugar donde descansan
                            los restos de José Bernardo Alzedo. Pág. 129.
                            <br><br>
                        Disponible en: <a href="http://hdl.handle.net/20.500.14428/80520" target="_blank" style="color: #ffffff;" >
                        Biblioteca Digital<br>
                            <br><br><br>
                        </a>
                    </p>
            </div>
        </div>
    </div>
</div>

<div class="fondoNegro" style="background-image: url('/assets/images/micrositio/micrositio37/BERNARDO-008.png'); background-size: cover; background-position: center;">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <img src="/assets/images/micrositio/micrositio37/BERNARDO-LINEA-002.png" width="90%">
                
                <div class="row ">
                    <div class="col"></div>
                    <div class="col-sm-10">
                        <p class="text-center text-white fontMS100 font-18">
                            <br>
                            <span>
                                <br><br>
                                «ALZEDO SE DESTACÓ EN MUCHOS ASPECTOS, COMO COMPOSITOR NO SOLO DE MÚSICA LIGERA SINO TAMBIÉN DE MISAS
                                SOLEMNES CON ACOMPAÑAMIENTO DE GRAN ORQUESTA, COMO ESCRITOR NO SOLO DE ENSAYOS PERIODÍSTICOS SINO
                                TAMBIÉN COMO EMINENTE TRATADISTA, COMO DIRECTOR NO SOLO DE COROS DE PEQUEÑOS CONVENTOS SINO TAMBIÉN
                                COMO DIRECTOR DE MÚSICA DE LA CATEDRAL DE SANTIAGO EN UNA ÉPOCA MUY ESPACIAL, TODO LO CUAL LE HACE
                                MERECEDOR DEL AGRADECIMIENTO DE LOS MÚSICOS DE AMBOS CONTINENTES».<br><br>
                                («HOMENAJE A JOSÉ BERNARDO ALZEDO (1788-1878)». ROBERT STEVENSON. 1971)   
                                <br><br>
                            </span>
                        </p>

                    </div>
                    <div class="col"></div>
                </div>
                
                <img src="/assets/images/micrositio/micrositio37/BERNARDO-LINEA-003.png" class="reflejo"
                    width="90%" style="margin-left: 10%">
            </div>
        </div>
    </div>
</div>

<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <!-- <div class="col-sm-1"></div> -->
                    <div class="col-sm-3 bott">
                        <img class="LineSubsec_Izq bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio37/BERNARDO-LINEA-001.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel" style="margin-bottom: 2%;" width="100%"
                            src="/assets/images/micrositio/micrositio37/BERNARDO-LINEA-001.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 120%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal  font-40">
                            ALZEDO Y LA REFLEXIÓN<br>
                            MUSICAL
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec_Izq bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio37/BERNARDO-LINEA-001.png">
                    </div>
                    <!-- <div class="col-sm-1"></div> -->
                    <div class="c100">
                        <img class="lineCel" style="margin-top: 2%;" width="100%"
                            src="/assets/images/micrositio/micrositio37/BERNARDO-LINEA-001.png">
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <p class="fontMS100 text-center font-22">
                            <br><br>
                            SEGÚN ARMANDO SÁNCHEZ MÁLAGA, «EN SANTIAGO DE CHILE, ALZEDO SE DEDICÓ A LA ENSEÑANZA
                            PARTICULAR; FUE PROFESOR EN CENTROS EDUCATIVOS Y MAESTRO EN CONVENTOS Y BANDAS MILITARES;
                            ABORDÓ EL ESTUDIO TEÓRICO Y EL PERIODISMO MUSICAL CONVIRTIÉNDOSE, EN OPINIÓN DEL
                            MUSICÓLOGO CHILENO SAMUEL CLARO, EN “EL PRIMER MÚSICO QUE REALIZÓ EN CHILE ESTUDIOS
                            CIENTÍFICOS MUSICALES DURANTE ESA ÉPOCA, PUBLICANDO ILUSTRADOS ARTÍCULOS EN EL SEMANARIO
                            MUSICAL Y EN EL PERIÓDICO EL FERROCARRIL; ADEMÁS DE SU FILOSOFÍA ELEMENTAL DE LA MÚSICA, QUE
                            RESUME SU EXPERIENCIA DOCENTE Y MUCHOS AÑOS DE INVESTIGACIÓN REALIZADA EN CHILE”».
                            <br><br>
                        </p>
                    </div> 
                </div>
                <div class="row">
                    <div class="col-sm-4">
                        <a href="http://hdl.handle.net/20.500.14428/79776" target="_blank">
                            <img width="100%" src="/assets/images/micrositio/micrositio37/BERNARDO-009.png">
                        </a>
                            <p class="text-center text-white font-12" style="background: #424342; padding-left: 5%; padding-right: 5%" >
                                <br><br>
                                José Bernardo Alzedo. Óleo de E. Apesteguía existente en el
                                Museo Nacional de Historia. Publicado en: Símbolos de la patria.
                                Pág. 198.<br>
                                    <br>
                                Disponible en: <a href="http://hdl.handle.net/20.500.14428/79776" target="_blank" style="color: #ffffff;" >
                                Biblioteca Digital<br>
                                    <br><br>
                                </a>
                            </p>
                    </div>
                    <div class="col-sm-4">
                        <a href="https://www.memoriachilena.gob.cl/archivos2/pdfs/MC0033012.pdf" target="_blank">
                            <img width="100%" src="/assets/images/micrositio/micrositio37/BERNARDO-010.png">
                        </a>
                            <p class="text-center text-white font-12" style="word-wrap: break-word; background: #424342; padding-left: 5%; padding-right: 5%;">
                                    <br><br>
                                Semanario Musical. – Santiago de Chile, 10 de agosto de 1852-24 de julio de 1852.<br>

                                    <br>
                                Disponible en:<br><a href="https://www.memoriachilena.gob.cl/archivos2/pdfs/MC0033012.pdf" target="_blank" style="color: #ffffff;" >
                                    https://www.memoriachilena.gob.cl/archivos2/pdfs/MC003
                                    3012.pdf<br>
                                    <br>
                                </a>
                            </p>
                    </div>
                    <div class="col-sm-4">
                        <a href="http://hdl.handle.net/20.500.14428/80519" target="_blank">
                            <img width="100%" src="/assets/images/micrositio/micrositio37/BERNARDO-011.png">
                        </a>
                            <p class="text-center text-white font-12" style="background: #424342; padding-left: 5%; padding-right: 5%" >
                                    <br><br>
                                Filosofía elemental de la música, ó sea, La exégesis de las
                                    doctrinas conducentes a su mejor inteligencia.<br>
                                    <br>
                                Disponible en: <a href="http://hdl.handle.net/20.500.14428/80519" target="_blank" style="color: #ffffff;" >
                                Biblioteca Digital<br>
                                    <br><br><br>
                                </a>
                            </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoNegro" style="background-image: url('/assets/images/micrositio/micrositio37/BERNARDO-008.png'); background-size: cover; background-position: center;">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <img src="/assets/images/micrositio/micrositio37/BERNARDO-LINEA-002.png" width="90%">
                
                <div class="row ">
                    <div class="col"></div>
                    <div class="col-sm-10">
                        <p class="text-center text-white fontMS100 font-18">
                            <br>
                            <span>
                                <br><br>
                                «HOMBRE SENCILLO, MAESTRO DE VOCACIÓN, GENEROSO CON SUS COLEGAS, AMANTE DE SU PAÍS, FUE POSEEDOR DE UNA
                                CULTURA ADMIRABLE ADQUIRIDA A TRAVÉS DE AÑOS DE LECTURAS QUE ABARCABAN LA TEORÍA MUSICAL, LA
                                HISTORIOGRAFÍA, LA FILOSOFÍA Y LA CIENCIA QUE VOLCÓ EN SU FILOSOFÍA ELEMENTAL DE LA MÚSICA, EL MÁS IMPORTANTE
                                TRABAJO DE TEORÍA MUSICAL ESCRITO EN NUESTRO CONTINENTE EN EL SIGLO XIX».<br><br>
                                («PRESENCIA DE ALZEDO». ARMANDO SÁNCHEZ MÁLAGA. 2012)   
                                <br><br>
                            </span>
                        </p>

                    </div>
                    <div class="col"></div>
                </div>
                
                <img src="/assets/images/micrositio/micrositio37/BERNARDO-LINEA-003.png" class="reflejo"
                    width="90%" style="margin-left: 10%">
            </div>
        </div>
    </div>
</div>

<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">

                    <div class="col-sm-3 bott">
                        <img class="LineSubsec_Izq bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio37/BERNARDO-LINEA-001.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel" style="margin-bottom: 2%;" width="100%"
                            src="/assets/images/micrositio/micrositio37/BERNARDO-LINEA-001.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 150%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal  font-40">
                            HIMNO NACIONAL DEL PERÚ<br>
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec_Izq bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio37/BERNARDO-LINEA-001.png">
                    </div>

                    <div class="c100">
                        <img class="lineCel" style="margin-top: 2%;" width="100%"
                            src="/assets/images/micrositio/micrositio37/BERNARDO-LINEA-001.png">
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <p class="fontMS100 text-center font-22">
                            <br><br>
                            «EN AGOSTO DE 1821, LUEGO DE LA JURA DE LA INDEPENDENCIA, LA GACETA MINISTERIAL PUBLICÓ LA
                            CONVOCATORIA PARA UN CERTAMEN DESTINADO A ESCOGER LA MARCHA NACIONAL DEL PERÚ.
                            PARTICIPARON SIETE COMPOSITORES, ENTRE LAS CUALES LA COMPOSICIÓN PRESENTADA POR ALZEDO FUE
                            LA ELEGIDA. LA PRIMERA AUDICIÓN SE LLEVÓ A CABO EN LA CASA DE LA ESCRITORA MANUELA DE RÁBAGO
                            DE RIGLOS Y EL ESTRENO PÚBLICO OCURRIÓ EN EL TEATRO DE LIMA EL 24 DE SETIEMBRE DEL MISMO AÑO,
                            POR LA CANTATRIZ LIMEÑA ROSA MERINO.<br>
                            «SE DESCONOCE EL DESTINO DE LA PARTITURA ORIGINAL. MÁS TARDE, EN AUSENCIA DE ALZEDO
                            APARECIERON DIVERSAS EDICIONES SIN SU AUTORIZACIÓN. A SU REGRESO DEFINITIVO AL PERÚ, ALZEDO
                            ACEPTÓ LA RESTAURACIÓN REALIZADA POR CLAUDIO REBAGLIATI EN VERSIONES PARA PIANO SOLO, BANDA
                            MILITAR Y GRAN ORQUESTA QUE AÑOS MÁS TARDE FUE DECLARADA OFICIAL E INTANGIBLE» (ARMANDO
                            SÁNCHEZ MÁLAGA)
                            <br><br>
                        </p>
                    </div> 
                </div>
                <div class="row">
                    <div class="col-sm-5">
                        <a href="https://hdl.handle.net/20.500.14428/65626" target="_blank">
                            <img width="100%" src="/assets/images/micrositio/micrositio37/BERNARDO-012.png">
                        </a>
                            <p class="text-center text-white font-12" style="background: #424342; padding-left: 5%; padding-right: 5%" >
                                <br><br>
                                Himno Nacional del Perú [música] : para canto y piano / música de
                                Bernardo de Alcedo.<br>
                                    <br>
                                Disponible en: <a href="https://hdl.handle.net/20.500.14428/65626" target="_blank" style="color: #ffffff;" >
                                Biblioteca Digital<br>
                                    <br><br>
                                </a>
                            </p>
                    </div>
                    <div class="col-sm-1"></div>
                    <div class="col-sm-5">
                        <div class="row" style="background: #424342; padding-top: 2%; padding-bottom: 2%;">
                            <div class="col-sm-6">
                                <br>
                                <a href="https://hdl.handle.net/20.500.14428/65621" target="_blank">                                
                                    <img width="100%" src="/assets/images/micrositio/micrositio37/BERNARDO-013.png">
                                </a>
                            </div>
                            <div class="col-sm-6">
                                <p class="text-center text-white font-12" style="background: #424342; padding-left: 5%; padding-right: 5%; padding-top: 20%;" >
                                    <br><br>
                                    Himno Nacional del Perú [música] : para piano
                                    / música de D. B. Alsedo ; arreglada por Carlos
                                    Juan Eklund. - Lima : [s.n, 1863?]. 1 partitura
                                    (3 p.) ; 33 cm.
                                    Para coro a 4 voces mixtas con
                                    acompañamiento de piano.<br>

                                    <br>
                                    Disponible en:<br><a href="https://hdl.handle.net/20.500.14428/65621" target="_blank" style="color: #ffffff;" >
                                        Biblioteca Digital<br>
                                        <br><br>
                                    </a>
                                </p>
                            </div>
                        </div>
                        <div class="row mt-5 " style="background: #424342; padding-top: 2%; padding-bottom: 2%;">
                            <div class="col-sm-6" >
                                    <p class="text-center text-white font-12" style="background: #424342; padding-left: 5%; padding-right: 5%; padding-top: 20%;" >
                                            <br><br>
                                            El Himno Nacional según una de las primeras
                                            versiones del músico italiano don Claudio
                                            Rebagliati, efectuada con autorización del
                                            maestro Alzedo. Lima, mayo 1869-1870; octubre
                                            de 1899. Publicado en: Símbolos de la patria /
                                            investigación, recopilación, edición y prólogo
                                            por Gustavo Pons Muzzo. Pág. 265.<br>
                                            <br>
                                        Disponible en: <a href="http://hdl.handle.net/20.500.14428/79776" target="_blank" style="color: #ffffff;" >
                                        Biblioteca Digital<br>
                                            <br>
                                        </a>
                                    </p>
                            </div>
                            <div class="col-sm-6">
                                <br>
                                <a href="http://hdl.handle.net/20.500.14428/79776" target="_blank">
                                    <img width="100%" src="/assets/images/micrositio/micrositio37/BERNARDO-014.png">
                                </a>
                            </div>
                        </div>

                    </div>
                    <div class="col-sm-1"></div>
                </div>

                <div class="row mt-5">
                    <div class="col-sm-11">
                        <div class="row">
                            <div class="col mx-3 mb-3" style="background: #424342; padding-top: 2%; padding-left: 2%; padding-right: 2%">
                                <a href="https://hdl.handle.net/20.500.14428/65623" target="_blank">
                                    <img width="100%" src="/assets/images/micrositio/micrositio37/BERNARDO-015A.png">
                                </a>
                                    <p class="text-center text-white font-12" style="background: #424342; padding-left: 5%; padding-right: 5%" >
                                        <br><br>
                                        Himno Nacional del Perú [música] / J. B. Alzedo.<br>
                                            
                                        Disponible en: <a href="https://hdl.handle.net/20.500.14428/65623" target="_blank" style="color: #ffffff;" >
                                        Biblioteca Digital<br>
                                            <br>
                                        </a>
                                        Video: <br><a href="https://www.youtube.com/watch?v=OVr0QSIEYuI&t=1728s" target="_blank" style="color: #ffffff;" >
                                            https://www.youtube.com/watch?v=OVr0QSIEYuI&t=<br>
                                                1728s
                                                <br><br>
                                            </a>
                                    </p>
                            </div>
                            <div class="col mx-3 mb-3" style="background: #424342; padding-top: 2%; padding-left: 2%; padding-right: 2%">
                                <a href="https://hdl.handle.net/20.500.14428/65631" target="_blank" >
                                    <img width="100%" src="/assets/images/micrositio/micrositio37/BERNARDO-016.png">
                                </a>
                                
                                    <p class="text-center text-white font-12" style="background: #424342; padding-left: 5%; padding-right: 5%" >
                                        <br><br>
                                        Himno Nacional del Perú [música] : reducción para
                                        piano / música del maestro José Bernardo Alzedo.<br>
                                            
                                        Disponible en: <a href="https://hdl.handle.net/20.500.14428/65631" target="_blank" style="color: #ffffff;" >
                                        Biblioteca Digital<br>
                                            <br>
                                        </a>
                                        Video: <br><a href="https://www.youtube.com/watch?v=Gxgq8u2ixw8" target="_blank" style="color: #ffffff;" >
                                            https://www.youtube.com/watch?v=Gxgq8u2ixw8
                                                <br><br>
                                            </a>
                                    </p>
                            </div>
                            <div class="col mx-3 mb-3" style="background: #424342; padding-top: 2%; padding-left: 4%; padding-right: 2%">
                                <a href="https://hdl.handle.net/20.500.14428/65630" target="_blank" style="color: #ffffff;" >
                                    <img width="94%" src="/assets/images/micrositio/micrositio37/BERNARDO-017.png">
                                </a>
                                    <p class="text-center text-white font-12" style="background: #424342; padding-left: 5%; padding-right: 5%" >
                                        <br><br>
                                        Himno Nacional peruano [música] : edición para
                                        piano con letra : en Fa mayor (original), en Re mayor
                                        (para colegios)<br>
                                            <br>
                                        Disponible en: <a href="https://hdl.handle.net/20.500.14428/65630" target="_blank" style="color: #ffffff;" >
                                        Biblioteca Digital<br>
                                            <br><br>
                                        </a>
                                    </p>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-1"></div>
                    
                </div>

                <div class="row">
                    <div class="col-sm-11">
                        <div class="row">
                            <div class="col-sm-2"></div>
                            <div class="col mx-3 mb-3" style="background: #424342; padding-top: 2%; padding-left: 2%; padding-right: 2%">
                                <a href="http://hdl.handle.net/20.500.14428/80236" target="_blank" >
                                    <img width="100%" src="/assets/images/micrositio/micrositio37/BERNARDO-018.png">
                                </a>
                                
                                    <p class="text-center text-white font-12" style="background: #424342; padding-left: 5%; padding-right: 5%" >
                                        <br><br>
                                        Ricordi facili di melodie [música] : Cancion
                                        Nazional del Perú / [José Bernardo Alcedo]<br>
                                            <br>
                                        Disponible en: <a href="http://hdl.handle.net/20.500.14428/80236" target="_blank" style="color: #ffffff;" >
                                        Biblioteca Digital<br>
                                            <br><br>
                                        </a>
                                    </p>
                            </div>
                            <div class="col mx-3 mb-3" style="background: #424342; padding-top: 2%; padding-left: 2%; padding-right: 2%">
                                <a href="https://hdl.handle.net/20.500.14428/65701" target="_blank" style="color: #ffffff;" >
                                    <img width="100%" src="/assets/images/micrositio/micrositio37/BERNARDO-019.png">
                                </a>
                                
                                    <p class="text-center text-white font-12" style="background: #424342; padding-left: 5%; padding-right: 5%" >
                                        <br><br>
                                        La marcha nacional del Perú = Peruvianischer
                                        national - marsch [música] : vaterlands lieder.<br>
                                            <br>
                                        Disponible en: <a href="https://hdl.handle.net/20.500.14428/65701" target="_blank" style="color: #ffffff;" >
                                        Biblioteca Digital<br>
                                            <br><br>
                                        </a>
                                    </p>
                            </div>
                            <div class="col-sm-2"></div>
                        </div>
                    </div>
                    <div class="col-sm-11"></div>
                </div>

            </div>
        </div>
    </div>
</div>

<div class="fondoNegro" style="background-image: url('/assets/images/micrositio/micrositio37/BERNARDO-008.png'); background-size: cover; background-position: center;">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <img src="/assets/images/micrositio/micrositio37/BERNARDO-LINEA-002.png" width="90%">
                
                <div class="row ">
                    <div class="col"></div>
                    <div class="col-sm-10">
                        <p class="text-center text-white fontMS100 font-18">
                            <br>
                            <span>
                                <br><br>
                                A LOS DIEZ Y OCHO AÑOS COMPUSO SU PRIMERA MISA EN RE MAYOR. ASOMBRÓ A TODOS TAN PREMATURO TRABAJO,
                                SIENDO MUCHOS LOS QUE NO CREÍAN QUE ERA OBRA SUYA, CIRCUNSTANCIA QUE HIZO SUFRIR AL NUEVO COMPOSITOR
                                MULTITUD DE DISIMULADOS EXÁMENES, EN TODOS LOS CUALES SALIÓ AIROSO SU TALENTO.<br><br>
                                D. JOSÉ BERNARDO ALZEDO». FÉLIX CIPRIANO CORONEL ZEGARRA. 1869  
                                <br><br>
                            </span>
                        </p>

                    </div>
                    <div class="col"></div>
                </div>
                
                <img src="/assets/images/micrositio/micrositio37/BERNARDO-LINEA-003.png" class="reflejo"
                    width="90%" style="margin-left: 10%">
            </div>
        </div>
    </div>
</div>

<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-3 bott">
                        <img class="LineSubsec_Izq bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio37/BERNARDO-LINEA-001.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel" style="margin-bottom: 2%;" width="100%"
                            src="/assets/images/micrositio/micrositio37/BERNARDO-LINEA-001.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 150%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal  font-40">
                            HIMNO NACIONAL DEL PERÚ<br>
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec_Izq bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio37/BERNARDO-LINEA-001.png">
                    </div>

                    <div class="c100">
                        <img class="lineCel" style="margin-top: 2%;" width="100%"
                            src="/assets/images/micrositio/micrositio37/BERNARDO-LINEA-001.png">
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-5" style="padding: 0%;" >
                        <br><br>
                        <a href="http://hdl.handle.net/20.500.14428/81132" target="_blank" style="color: #ffffff;" >
                            <img width="100%" src="/assets/images/micrositio/micrositio37/BERNARDO-020.png">
                        </a>
                        
                    </div>
                    <div class="col-sm-7" style="padding: 0%;">
                        <div class="row">
                            <div class="col-sm-12" style="padding: 2% 10%;">
                                <p class="fontMS100 text-justify font-22">
                                    <br><br>
                                    DE ACUERDO A JOSÉ MANUEL IZQUIERDO, «ESTAS
                                    PIEZAS SON PROBABLEMENTE COMPUESTAS EN LIMA
                                    ANTES DE 1823, O EN SU DEFECTO SON VERSIONES
                                    ELABORADAS O REORQUESTADAS DE OBRAS QUE
                                    PODEMOS SUPONER CORRESPONDEN A ESTE PERÍODO
                                    DE LA VIDA DE ALZEDO, POR ASPECTOS ESTILÍSTICOS Y
                                    LA MATERIALIDAD DE LOS MANUSCRITOS».
                                    
                                </p>
                            </div>
                            <div class="col-sm-12">
                                <p class="text-center text-white font-16" style="background: #424342; padding-left: 5%; padding-right: 5%;" >
                                    <br><br>
                                    «La Virgen de las Mercedes, Patrona de las Armas del Perú». Siglo XIX. Publicada en: Mundial:
                                    revista ilustrada peruana. No. 228. Lima, 19 de setiembre de 1924, y reproducida en: Concierto
                                    de gala de música patriótica de José Bernardo Alzedo : colección de la Biblioteca Nacional del
                                    Perú. Cuarta edición. Lima: Biblioteca Nacional del Perú, 2015. Pág.20.<br>
                                    <br>
                                    Disponible en<br><a href="http://hdl.handle.net/20.500.14428/81132" target="_blank" style="color: #ffffff;" >
                                        Biblioteca Digital<br>
                                        <br><br>
                                    </a>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row mt-5">
                    <div class="col-sm-1"></div>
                    <div class="col mx-3 mb-3">
                        <a href="http://hdl.handle.net/20.500.14428/80234" target="_blank">
                            <img width="100%" src="/assets/images/micrositio/micrositio37/BERNARDO-021.png">
                        </a>
                            <p class="text-center text-white font-12" style="background: #424342; padding-left: 5%; padding-right: 5%" >
                                <br><br>
                                Villancico a 3 y a 4 voces, con
                                acompañamiento de dos violines, dos
                                clarinetes, dos trompas, órgano y bajo
                                [música] / por J. B. Alzedo.<br>
                                    <br>
                                Disponible en: <a href="http://hdl.handle.net/20.500.14428/80234" target="_blank" style="color: #ffffff;" >
                                Biblioteca Digital<br>
                                    <br><br><br>
                                </a>
                            </p>
                    </div>
                    <div class="col mx-3 mb-3">
                        <a href="http://hdl.handle.net/20.500.14428/80224" target="_blank" style="color: #ffffff;" >
                            <img width="100%" src="/assets/images/micrositio/micrositio37/BERNARDO-022.png">
                        </a>
                            <p class="text-center text-white font-12" style="background: #424342; padding-left: 5%; padding-right: 5%" >
                                <br><br>
                                Cuatro Motetes Penitenciales compuestos en
                                partes separadas sin partitura, con
                                acompañamiento de dos violines, dos oboes,
                                dos trompas y bajo [música] / música y
                                palabras de J. B. Alzedo.<br>
                                    <br>
                                Disponible en: <a href="http://hdl.handle.net/20.500.14428/80224" target="_blank" style="color: #ffffff;" >
                                Biblioteca Digital<br>
                                    <br>
                                </a>
                            </p>
                    </div>
                    <div class="col mx-3 mb-3">
                        <a href="http://hdl.handle.net/20.500.14428/80131" target="_blank" style="color: #ffffff;" >
                            <img width="100%" src="/assets/images/micrositio/micrositio37/BERNARDO-023.png">
                        </a>
                        
                            <p class="text-center text-white font-12" style="background: #424342; padding-left: 5%; padding-right: 5%" >
                                <br><br>
                                Tota pulcra est María a 3 voces, con
                                acompañamiento de 2 violines, 1 flauta, 2
                                clarinetes, 2 trompas y 1 bajo [música] /
                                [José Bernardo Alzedo].<br>
                                    <br>
                                Disponible en: <a href="http://hdl.handle.net/20.500.14428/80131" target="_blank" style="color: #ffffff;" >
                                Biblioteca Digital<br>
                                    <br><br><br>
                                </a>
                            </p>
                    </div>
                    <div class="col-sm-1"></div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoNegro" style="background-image: url('/assets/images/micrositio/micrositio37/BERNARDO-008.png'); background-size: cover; background-position: center;">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <img src="/assets/images/micrositio/micrositio37/BERNARDO-LINEA-002.png" width="90%">
                
                <div class="row ">
                    <div class="col"></div>
                    <div class="col-sm-10">
                        <p class="text-center text-white fontMS100 font-18">
                            <br>
                            <span>
                                <br><br>
                                «ARTE, EDUCACIÓN Y CULTURA, CONSTITUÍAN PARA ALZEDO LOS HILOS DE UNA URDIMBRE SINÉRGICA QUE LE DA DIGNIDAD
                                Y ESPLENDIDEZ A LOS PUEBLOS Y CUYO FRUTO ES LA CIVILIZACIÓN»<br><br>
                                (CARMEN ESCOBEDO REVOREDO. 2018) 
                                <br><br>
                            </span>
                        </p>
                    </div>
                    <div class="col"></div>
                </div>
                
                <img src="/assets/images/micrositio/micrositio37/BERNARDO-LINEA-003.png" class="reflejo"
                    width="90%" style="margin-left: 10%">
            </div>
        </div>
    </div>
</div>

<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">

                    <div class="col-sm-3 bott">
                        <img class="LineSubsec_Izq bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio37/BERNARDO-LINEA-001.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel" style="margin-bottom: 2%;" width="100%"
                            src="/assets/images/micrositio/micrositio37/BERNARDO-LINEA-001.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 120%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal  font-40">
                            OBRAS RELIGIOSAS<br>
                            INTERMEDIAS (c. 1840-1860)
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec_Izq bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio37/BERNARDO-LINEA-001.png">
                    </div>

                    <div class="c100">
                        <img class="lineCel" style="margin-top: 2%;" width="100%"
                            src="/assets/images/micrositio/micrositio37/BERNARDO-LINEA-001.png">
                    </div>

                    <p class="fontMS100 text-center font-22">
                        <br><br><br><br>
                        DE ACUERDO A LO SEÑALADO POR EL INVESTIGADOR JOSÉ MANUEL IZQUIERDO, «ESTE CONJUNTO DE
                        OBRAS COMPRENDE EL GRUESO DE LA ACTIVIDAD DE JOSÉ BERNARDO ALZEDO COMO MAESTRO DE
                        CAPILLA DE LA CATEDRAL DE SANTIAGO DE CHILE, PRINCIPALMENTE OBRAS ORQUESTALES CON CORO HASTA
                        1850, Y LUEGO DE LA LLEGADA DEL GRAN ÓRGANO FLIGHT PARA VOCES Y ÓRGANO, EN REDUCCIÓN DE
                        OBRAS PREVIAS O COMO OBRAS ORIGINALES. POR RAZONES DE ARCHIVO COMO DE SU OFICIO, ESTE ES EL
                        GRUPO MÁS IMPORTANTE DE OBRAS DE ALZEDO».
                        <br><br>
                    </p>

                </div>

                <div class="row mt-5">
                    <div class="col mx-2 mb-2">
                        <a href="http://hdl.handle.net/20.500.14428/80134" target="_blank">
                            <img width="100%" src="/assets/images/micrositio/micrositio37/BERNARDO-024.png">
                        </a>
                        
                            <p class="fontMS100Italic text-center text-white font-11" style="background: #424342; padding-left: 5%; padding-right: 5%" >
                                <br><br>
                                Cántico de Moisés, Cantemus Domine Gloriose :
                                para el aniversario de la Yndependencia a seis y
                                más voces; con acompañamiento de dos violines,
                                viola, dos clarinetes, flauta, dos trompas, clarín,
                                trombón, órgano y bajo [música] / por J. B. Alzedo.<br>
                                    <br>
                                Disponible en: <a href="http://hdl.handle.net/20.500.14428/80134" target="_blank" style="color: #ffffff;" >
                                Biblioteca Digital<br>
                                    <br><br>
                                </a>
                            </p>
                    </div>
                    <div class="col mx-2 mb-2">
                        <a href="http://hdl.handle.net/20.500.14428/80222" target="_blank" >
                            <img width="100%" src="/assets/images/micrositio/micrositio37/BERNARDO-025.png">
                        </a>
                        
                            <p class="fontMS100Italic text-center text-white font-12" style="background: #424342; padding-left: 5%; padding-right: 5%" >
                                <br><br>
                                Motete a la Ssma. Virgen, a 4 y a 8 voces; con
                                acompañamiento de grande orquesta
                                [música] / por J. B. Alzedo.<br>
                                    <br>
                                Disponible en: <a href="http://hdl.handle.net/20.500.14428/80222" target="_blank" style="color: #ffffff;" >
                                Biblioteca Digital<br>
                                    <br><br><br><br>
                                </a>
                            </p>
                    </div>
                    <div class="col mx-2 mb-2">
                        <a href="http://hdl.handle.net/20.500.14428/80221" target="_blank" >
                            <img width="100%" src="/assets/images/micrositio/micrositio37/BERNARDO-026.png">
                        </a>
                        
                            <p class="fontMS100Italic text-center text-white font-12" style="background: #424342; padding-left: 5%; padding-right: 5%" >
                                <br><br>
                                Motete a la Purísima Concepción, a 4 y a 8 voces
                                [música] / por J. B. Alzedo.<br>
                                    <br>
                                Disponible en: <a href="http://hdl.handle.net/20.500.14428/80221" target="_blank" style="color: #ffffff;" >
                                Biblioteca Digital<br>
                                    <br><br><br><br><br>
                                </a>
                            </p>
                    </div>
                    <div class="col mx-2 mb-2">
                        <a href="http://hdl.handle.net/20.500.14428/80125" target="_blank" >
                            <img width="100%" src="/assets/images/micrositio/micrositio37/BERNARDO-027.png">
                        </a>
                        
                            <p class="fontMS100Italic text-center text-white font-12" style="background: #424342; padding-left: 5%; padding-right: 5%" >
                                <br><br>
                                Gloria Laus y Pasión del Domingo, a 4 y a 8
                                voces; con acompañamiento de dos violines,
                                viola, flauta, clarinetes, corneta pistón,
                                trompas, trombón, violoncelo y bajo
                                [música] / por J. B. Alzedo<br>
                                    <br>
                                Disponible en: <a href="http://hdl.handle.net/20.500.14428/80125" target="_blank" style="color: #ffffff;" >
                                Biblioteca Digital<br>
                                    <br>
                                </a>
                            </p>
                    </div>
                </div>
                <div class="row mt-5">
                    <div class="col mx-2 mb-2">
                        <a href="http://hdl.handle.net/20.500.14428/80130" target="_blank" >
                            <img width="100%" src="/assets/images/micrositio/micrositio37/BERNARDO-028.png">
                        </a>
                        
                            <p class="fontMS100Italic text-center text-white font-12" style="background: #424342; padding-left: 5%; padding-right: 5%" >
                                <br><br>
                                Tantum ergo a 4 y a 8 voces, con
                                acompañamiento de grande orquesta [música] /
                                por J. B. Alzedo.<br>
                                    <br>
                                Disponible en: <a href="http://hdl.handle.net/20.500.14428/80130" target="_blank" style="color: #ffffff;" >
                                Biblioteca Digital<br>
                                    <br><br>
                                </a>
                            </p>
                    </div>
                    <div class="col mx-2 mb-2">
                        <a href="http://hdl.handle.net/20.500.14428/80128" target="_blank"  >
                            <img width="100%" src="/assets/images/micrositio/micrositio37/BERNARDO-029.png">
                        </a>
                        
                            <p class="fontMS100Italic text-center text-white font-12" style="background: #424342; padding-left: 5%; padding-right: 5%" >
                                <br><br>
                                Plegaria al Ser Supremo [á tres voces iguales,
                                con acompañamiento de orquesta] [música] /
                                por J. B. Alzedo.<br>
                                    <br>
                                Disponible en: <a href="http://hdl.handle.net/20.500.14428/80128" target="_blank" style="color: #ffffff;" >
                                Biblioteca Digital<br>
                                    <br>
                                </a>
                            </p>
                    </div>
                    <div class="col mx-2 mb-2">
                        <a href="http://hdl.handle.net/20.500.14428/80124" target="_blank" >
                            <img width="100%" src="/assets/images/micrositio/micrositio37/BERNARDO-030.png">
                        </a>
                        
                            <p class="fontMS100Italic text-center text-white font-11" style="background: #424342; padding-left: 5%; padding-right: 5%" >
                                <br><br>
                                Domine ad adjuvandum, a 4 y a 8 voces, con
                                acompañamiento de dos violines, viola, dos
                                clarinetes, flauta, dos trompas, clarín, trombón,
                                órgano y bajo [música] / por J. B. Alzedo.<br>
                                    <br>
                                Disponible en: <a href="http://hdl.handle.net/20.500.14428/80124" target="_blank" style="color: #ffffff;" >
                                Biblioteca Digital<br>
                                    <br>
                                </a>
                            </p>
                    </div>
                    <div class="col mx-2 mb-2">
                        <a href="http://hdl.handle.net/20.500.14428/80220" target="_blank" style="color: #ffffff;" >
                            <img width="100%" src="/assets/images/micrositio/micrositio37/BERNARDO-031.png">
                        </a>
                        
                            <p class="fontMS100Italic text-center text-white font-12" style="background: #424342; padding-left: 5%; padding-right: 5%" >
                                <br><br>
                                Motete Ave Stella Matutina, a 4 voces [música]
                                / J. B. Alzedo.<br>
                                    <br>
                                Disponible en: <a href="http://hdl.handle.net/20.500.14428/80220" target="_blank" style="color: #ffffff;" >
                                Biblioteca Digital<br>
                                    <br><br><br>
                                </a>
                            </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoNegro" style="background-image: url('/assets/images/micrositio/micrositio37/BERNARDO-008.png'); background-size: cover; background-position: center;">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <img src="/assets/images/micrositio/micrositio37/BERNARDO-LINEA-002.png" width="90%">
                
                <div class="row ">
                    <div class="col"></div>
                    <div class="col-sm-10">
                        <p class="text-center text-white fontMS100 font-18">
                            <br>
                            <span>
                                <br><br>
                                «(…) LA INVESTIGACIÓN SOBRE ALZEDO SE HA HECHO A ESPALDAS DE SU MÚSICA, CONSIDERADA POR PROMINENTES
                                AUTORES EN PERÚ Y CHILE COMO DE BAJO NIVEL, NO A LA ALTURA DE SU SAGRADO HIMNO. ESTO ES UN ABSURDO: A
                                ALZEDO DEBEMOS ENTENDERLE EN SU CONTEXTO, SEGÚN SUS IDEALES ESTÉTICOS E INTENCIONES COMO ARTISTA. LAS
                                IDEAS DE LO QUE ES UN “BUEN COMPOSITOR” ENTONCES, EN AMÉRICA LATINA, NO SON NI LAS DE UN BEETHOVEN NI UN
                                SCHUMANN, SINO ALGO COMPLETAMENTE DISTINTO. PARA ALZEDO (…) EL BUEN COMPOSITOR NO ES EL GRAN GENIO
                                RUPTURISTA, O QUIEN SABE EXPRESAR MEJOR SUS EMOCIONES INTERNAS EN UN ARTE ABSTRACTO (IDEALES ROMÁNTICOS
                                ALEMANES DEL PERÍODO), SINO QUIEN SABE ADAPTAR LOS TEXTOS CORRECTAMENTE Y CON LA MEJOR EXPRESIÓN A LA
                                MÚSICA».<br><br>
                                (JOSÉ BERNARDO ALZEDO (1788-1878): BIOGRAFÍA DE UN MÚSICO PERUANO. JOSÉ MANUEL IZQUIERDO. 201?)
                                <br><br>
                            </span>
                        </p>
                    </div>
                    <div class="col"></div>
                </div>
                
                <img src="/assets/images/micrositio/micrositio37/BERNARDO-LINEA-003.png" class="reflejo"
                    width="90%" style="margin-left: 10%">
            </div>
        </div>
    </div>
</div>

<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">

                    <div class="col-sm-3 bott">
                        <img class="LineSubsec_Izq bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio37/BERNARDO-LINEA-001.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel" style="margin-bottom: 2%;" width="100%"
                            src="/assets/images/micrositio/micrositio37/BERNARDO-LINEA-001.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 120%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal  font-40">
                            OBRAS RELIGIOSAS<br>
                            TARDÍAS (c. 1863-1878)
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec_Izq bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio37/BERNARDO-LINEA-001.png">
                    </div>

                    <div class="c100">
                        <img class="lineCel" style="margin-top: 2%;" width="100%"
                            src="/assets/images/micrositio/micrositio37/BERNARDO-LINEA-001.png">
                    </div>

                    <p class="fontMS100 text-center font-22">
                        <br><br><br><br>
                        SE TRATA DE COMPOSICIONES QUE ALZEDO COMPUSO EN SUS ÚLTIMOS AÑOS EN SANTIAGO DE CHILE O EN
                        LIMA. SIN EMBARGO, COMO SEÑALA JOSÉ MANUEL IZQUIERDO, «ALGUNAS DE ESTAS OBRAS, POR LA
                        CALIGRAFÍA O EL ESTADO EN QUE SE ENCUENTRAN, PODRÍAN NO SER DE ALZEDO, PERO DADO QUE
                        PERTENECEN A SU COLECCIÓN Y TIENEN UN ESTILO QUE PUEDE ADSCRIBIRLE A ÉL, TIENE SENTIDO
                        CONSIDERARLAS AQUÍ HASTA QUE NO SE PRUEBE LO CONTRARIO».
                        <br><br>
                    </p>
                </div>

                <div class="row mt-5">
                    <div class="col mx-2 mb-2">
                        <a href="http://hdl.handle.net/20.500.14428/80129" target="_blank" >
                            <img width="100%" src="/assets/images/micrositio/micrositio37/BERNARDO-042.png">
                        </a>
                        
                            <p class="fontMS100Italic text-center text-white font-11" style="background: #424342; padding-left: 5%; padding-right: 5%" >
                                <br><br>
                                Ynvitatorio de difuntos, a cuatro voces con
                                acompañamiento de dos violines y un
                                principal, viola, flauta, dos clarinetes,
                                corneta pistón, dos trompas, trombón,
                                timbal, órgano, violoncelo y bajo [música] :
                                / por J. B. Alzedo.<br>
                                    <br>
                                Disponible en: <a href="http://hdl.handle.net/20.500.14428/80129" target="_blank" style="color: #ffffff;" >
                                Biblioteca Digital<br>
                                    <br>
                                </a>
                            </p>
                    </div>
                    <div class="col mx-2 mb-2">
                        <a href="http://hdl.handle.net/20.500.14428/80126" target="_blank" >
                            <img width="100%" src="/assets/images/micrositio/micrositio37/BERNARDO-043.png">
                        </a>
                        
                            <p class="fontMS100Italic text-center text-white font-11" style="background: #424342; padding-left: 5%; padding-right: 5%" >
                                <br><br>
                                Misa a 4 y a 8 voces [FaM], con
                                acompañamiento de dos violines, viola,
                                flauta y flautín, dos clarinetes, dos pistones,
                                dos trompas, trombón, timbal, órgano,
                                violoncelo y bajo [música] / por J. B. Alzedo.<br>
                                    <br>
                                Disponible en: <a href="http://hdl.handle.net/20.500.14428/80126" target="_blank" style="color: #ffffff;" >
                                Biblioteca Digital<br>
                                    <br>
                                </a>
                            </p>
                    </div>
                    <div class="col mx-2 mb-2">
                        <a href="http://hdl.handle.net/20.500.14428/80219" target="_blank" style="color: #ffffff;" >
                            <img width="100%" src="/assets/images/micrositio/micrositio37/BERNARDO-044.png">
                        </a>
                        
                            <p class="fontMS100Italic text-center text-white font-12" style="background: #424342; padding-left: 5%; padding-right: 5%" >
                                <br><br>
                                [Kirie eleyson, para 1° y 2° tenor]
                                [música] / [J. B. Alzedo]. -- [Santiago de
                                Chile? : s.n, 1850?].<br>
                                    <br>
                                Disponible en: <a href="http://hdl.handle.net/20.500.14428/80219" target="_blank" style="color: #ffffff;" >
                                Biblioteca Digital<br>
                                    <br><br><br>
                                </a>
                            </p>
                    </div>
                    <div class="col mx-2 mb-2">
                        <a href="http://hdl.handle.net/20.500.14428/80127" target="_blank" style="color: #ffffff;" >
                            <img width="100%" src="/assets/images/micrositio/micrositio37/BERNARDO-045.png">
                        </a>
                        
                            <p class="fontMS100Italic text-center text-white font-12" style="background: #424342; padding-left: 5%; padding-right: 5%" >
                                <br><br>
                                Misa de Requiem, á tres [voces]
                                [música] / [José Bernardo Alzedo]. --
                                [Santiago de Chile? : s.n, 1865?].<br>
                                    <br>
                                Disponible en: <a href="http://hdl.handle.net/20.500.14428/80127" target="_blank" style="color: #ffffff;" >
                                Biblioteca Digital<br>
                                    <br><br><br>
                                </a>
                            </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoNegro" style="background-image: url('/assets/images/micrositio/micrositio37/BERNARDO-008.png'); background-size: cover; background-position: center;">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <img src="/assets/images/micrositio/micrositio37/BERNARDO-LINEA-002.png" width="90%">
                
                <div class="row ">
                    <div class="col"></div>
                    <div class="col-sm-10">
                        <p class="text-center text-white fontMS100 font-18">
                            <br>
                            <span>
                                <br><br>
                                «PARA ALZEDO, COMO SEÑALA EN SU FILOSOFÍA, EL “CIENTÍFICO Y VERDADERO MÚSICO” ES AQUEL QUE, ELEGIDO POR LA
                                NATURALEZA, UNA A ELLA LA “POSESIÓN DE UNA PERFECTA TEORÍA, FUNDADA EN LOS PRINCIPIOS DE LA CIENCIA
                                DERIVADOS DE LA NATURALEZA, EL CONOCIMIENTO DEL CORAZÓN HUMANO, Y LOS RESORTES DE EXCITAR SUS
                                SENTIMIENTOS, Y LA JUICIOSA OBSERVACIÓN DE LOS DIVERSOS METROS DE LA POESÍA SAGRADA Y PROFANA PARA PODERLA
                                SIGNIFICAR”».<br><br>
                                (JOSÉ BERNARDO ALZEDO (1788-1878): BIOGRAFÍA DE UN MÚSICO PERUANO. JOSÉ MANUEL IZQUIERDO. 201?)
                                <br><br>
                            </span>
                        </p>
                    </div>
                    <div class="col"></div>
                </div>
                
                <img src="/assets/images/micrositio/micrositio37/BERNARDO-LINEA-003.png" class="reflejo"
                    width="90%" style="margin-left: 10%">
            </div>
        </div>
    </div>
</div>

<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">

                    <div class="col-sm-3 bott">
                        <img class="LineSubsec_Izq bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio37/BERNARDO-LINEA-001.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel" style="margin-bottom: 2%;" width="100%"
                            src="/assets/images/micrositio/micrositio37/BERNARDO-LINEA-001.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 120%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal  font-40">
                            MÚSICA PATRIÓTICA<br>
                            DE LA INDEPENDENCIA
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec_Izq bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio37/BERNARDO-LINEA-001.png">
                    </div>

                    <div class="c100">
                        <img class="lineCel" style="margin-top: 2%;" width="100%"
                            src="/assets/images/micrositio/micrositio37/BERNARDO-LINEA-001.png">
                    </div>
                </div>

                <div class="row mt-5">
                    <div class="col-sm-6">
                        <br><br>
                        <a href="http://hdl.handle.net/20.500.14428/79265" target="_blank">
                            <img width="100%" src="/assets/images/micrositio/micrositio37/BERNARDO-032.png">
                        </a>
                        
                            <p class="text-center text-white font-12" style="background: #424342; padding-left: 5%; padding-right: 5%" >
                                <br><br>
                                «[Chichera]». Acuarela de Pancho Fierro. [cerca 1845]<br>
                                    <br>
                                Disponible en: <a href="http://hdl.handle.net/20.500.14428/79265" target="_blank" style="color: #ffffff;" >
                                Biblioteca Digital<br>
                                    <br><br>
                                </a>
                            </p>
                    </div>
                    <div class="col-sm-6">
                        <p class="text-justify font-24" style="padding-left: 5%; padding-right: 5%" >
                            <br><br><br><br>
                            RESPECTO A ESTAS OBRAS, VÍCTOR RONDÓN
                            SOSTIENE LO SIGUIENTE: «LAS CANCIONES
                            PATRIÓTICAS DE JOSÉ BERNARDO ALZEDO,
                            ENFRENTADAS DESDE LA PERSPECTIVA DE UN
                            CREADOR ÚNICO, REFLEJAN UN AMPLIO
                            ESPECTRO DE PERSPECTIVAS Y POSIBILIDADES, NO
                            TODAS ABARCABLES DENTRO DE LOS MISMOS
                            MODELOS IDEOLÓGICOS. LA ANGUSTIA DE LA
                            DESPEDIDA DE LAS CHILENAS Y EL JOLGORIO DE LA
                            CHICHA SON, EN CONTRASTE, EXPRESIONES
                            CONCRETAS DE LOS MUCHOS MODOS DE
                            APROXIMARSE AL IDEAL PATRIÓTICO EN PERÚ
                            DENTRO DE LA DÉCADA DE 1820».<br>
                            <br>
                        </p>
                    </div>

                </div>

                <div class="row mt-5">

                    <div class="col mx-2 mb-2">
                        <a href="http://hdl.handle.net/20.500.14428/80228" target="_blank">
                            <img width="100%" src="/assets/images/micrositio/micrositio37/BERNARDO-033.png">
                        </a>
                        
                            <p class="fontMS100Italic text-center text-white font-11" style="background: #424342; padding-left: 5%; padding-right: 5%" >
                                <br><br>
                                La Chicha [música] : canzoneta peruana / por J. B. Alzedo.
                                – Paris : Mayence Chez les Fils de B. Schott, [1921?].<br>
                                    <br>
                                Disponible en: <a href="http://hdl.handle.net/20.500.14428/80228" target="_blank" style="color: #ffffff;" >
                                Biblioteca Digital<br>
                                    <br>
                                </a>
                                Video: <a href="https://www.youtube.com/watch?v=NOD_EK6T-Cc" target="_blank" style="color: #ffffff;" >
                                    https://www.youtube.com/watch?v=NOD_EK6T-Cc<br>
                                        <br>
                                    </a>
                                    Concierto de Gala por Fiestas Patrias a cargo de la
                                    Orquesta Sinfónica de la Dirección Desconcentrada de
                                    Cultura del Cusco, el 26 de julio de 2019.<br><br><br>
                            </p>
                    </div>
                    <div class="col mx-2 mb-2">
                        <a href="http://hdl.handle.net/20.500.14428/80229" target="_blank" style="color: #ffffff;" >
                            <img width="100%" src="/assets/images/micrositio/micrositio37/BERNARDO-034.png">
                        </a>
                        
                            <p class="fontMS100Italic text-center text-white font-12" style="background: #424342; padding-left: 5%; padding-right: 5%" >
                                <br><br>
                                La Cora [música] : canción peruana / por J. B. Alzedo. --
                                [Lima? : s.n, 1823?].<br>
                                    <br>
                                Disponible en: <a href="http://hdl.handle.net/20.500.14428/80229" target="_blank" style="color: #ffffff;" >
                                Biblioteca Digital<br>
                                    <br><br>
                                </a>
                                Video: <a href="https://www.youtube.com/watch?v=OVr0QSIEYuI&t=1728s" target="_blank" style="color: #ffffff;" >
                                    https://www.youtube.com/watch?v=OVr0QSIEYuI&t=1728s<br>
                                        <br>
                                    </a>
                                    Concierto de Gala de Música Patriótica de José Bernardo
                                    Alzedo. Cusco, 26 de agosto de 2014.<br><br><br>
                            </p>
                    </div>
                    <div class="col mx-2 mb-2">
                        <a href="http://hdl.handle.net/20.500.14428/80230" target="_blank" >
                            <img width="100%" src="/assets/images/micrositio/micrositio37/BERNARDO-035.png">
                        </a>
                        
                            <p class="fontMS100Italic text-center text-white font-12" style="background: #424342; padding-left: 5%; padding-right: 5%" >
                                <br><br>
                                La despedida de las chilenas al ejército de San Martín
                                libertador del Perú [música] / por J. B. Alzedo.<br>
                                    <br>
                                Disponible en: <a href="http://hdl.handle.net/20.500.14428/80230" target="_blank" style="color: #ffffff;" >
                                Biblioteca Digital<br>
                                    <br>
                                </a>
                                Video: <a href="https://www.youtube.com/watch?v=FnSpMDi50bs" target="_blank" style="color: #ffffff;" >
                                    https://www.youtube.com/watch?v=FnSpMDi50bs<br>
                                        <br>
                                    </a>
                                    Concierto ofrecido por la Orquesta Sinfónica Nacional
                                    Juvenil Bicentenario durante el confinamiento por la
                                    COVID-19. Mayo de 2021.<br><br>
                            </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-5 bott">
                        <img class="LineSubsec_Izq bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio37/BERNARDO-LINEA-004.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel" style="margin-bottom: 2%;" width="100%"
                            src="/assets/images/micrositio/micrositio37/BERNARDO-LINEA-004.png">
                    </div>
                    <div class="col-sm-7"></div>
                </div>

                <div class="row">
                    <div class="col-sm-12">
                        <p class="text-justify font-24" >
                            <br><br>
                            LAS OBRAS DE JOSÉ BERNARDO ALZEDO SE PRESERVAN EN LA BIBLIOTECA NACIONAL DEL PERÚ Y
                            OTRAS ENTIDADES COMO LA CATEDRAL METROPOLITANA DE SANTIAGO DE CHILE, EL SEMINARIO
                            PONTIFICIO MAYOR DE SANTIAGO, EL ARCHIVO Y BIBLIOTECA NACIONALES DE BOLIVIA Y EL ARCHIVO
                            Y BIBLIOTECA ARZOBISPALES DE SUCRE (BOLIVIA).<br>
                            <br>
                        </p>
                    </div>
                </div>

                <div class="row mt-5">
                    <div class="col-sm-6">                      
                        <div class="row" style="color: #000000">
                            <div class="col-sm-2" style="width: 10%">
                                <img src="/assets/images/micrositio/micrositio37/BERNARDO-ICONO-001.png">
                            </div>
                            <div class="col-sm-10">
                                <p class="fontMS500 font-14" style="word-wrap: break-word;">
                                    La Araucana [música] : obertura, con dos violines y uno principal,
                                    viola, flauta, flautín, dos clarinetes, pistón, dos trompas, trombón,
                                    timbal, violoncelo y bajo 
                                    <span class="fontMS100">/ por J. B. Alzedo. -- [Lima? : s.n, 1845?].
                                    <br><br>
                                    Disponible en:
                                    <a href="http://hdl.handle.net/20.500.14428/80231" target="_blank" style="color: #000000;">http://hdl.handle.net/20.500.14428/80231</a>
                                    <br><br>
                                    Video:
                                    <a href="https://www.youtube.com/watch?v=HRma9XBZrV4" target="_blank" style="color: #000000;">https://www.youtube.com/watch?v=HRma9XBZrV4</a>
                                    <br>
                                    Interpretación de la Orquesta Sinfónica del Perú. [19 de agosto de
                                    2021].
                                    <br><br>
                                    La obertura La Araucana, única obra orquestal que sobrevive, fue
                                    anunciada en El Comercio para la función del 9 de junio de 1842,
                                    como obertura orquestal a una obra de teatro, Rita la Española o
                                    El Solitario Kirbán».
                                    </span>
                                    <br><br>
                                </p>
                            </div>
                            <div class="col-sm-2" style="width: 10%">
                                <img src="/assets/images/micrositio/micrositio37/BERNARDO-ICONO-001.png">
                            </div>
                            <div class="col-sm-10">
                                <p class="fontMS500 font-14" style="word-wrap: break-word;">
                                    Himno guerrero en la vuelta de los españoles a las Yslas de Chincha
                                    [música] / 
                                    <span class="fontMS100">por J. Bernardo Alzedo. -- [Lima? : s.n, 1825?].
                                    <br><br>
                                    Disponible en:
                                    <a href="http://hdl.handle.net/20.500.14428/80233" target="_blank" style="color: #000000;">http://hdl.handle.net/20.500.14428/80233</a>
                                    <br><br>
                                    </span>
                                </p>
                            </div>
                            <div class="col-sm-2" style="width: 10%">
                                <img src="/assets/images/micrositio/micrositio37/BERNARDO-ICONO-001.png">
                            </div>
                            <div class="col-sm-10">
                                <p class="fontMS500 font-14" style="word-wrap: break-word;">
                                    Motete para la recepción del Presidente de la República [música] /
                                    <span class="fontMS100">por J. B. Alzedo. -- [Lima? : s.n, 1840?].
                                    <br><br>
                                    Disponible en:
                                    <a href="http://hdl.handle.net/20.500.14428/80223" target="_blank" style="color: #000000;">http://hdl.handle.net/20.500.14428/80223</a>
                                    <br><br>
                                    «Esta música religiosa de alabanza para la petición a Dios,
                                    compuesta por Alzedo a principios del siglo XIX, era un evento
                                    musical exclusivo en el Perú, daba el carácter presidencialista a las
                                    ceremonias patrióticas. En ese sentido, el texto de dicho motete se
                                    refería implícitamente al conductor de una nación que pedía al
                                    poderoso para ser ungido, esto es, recibir el aceite sacramental y
                                    ser digno para recibir a su pueblo». (David Vargas T.)
                                    <br><br>
                                    </span>
                                </p>
                            </div>
                            <div class="col-sm-2" style="width: 10%">
                                <img src="/assets/images/micrositio/micrositio37/BERNARDO-ICONO-001.png">
                            </div>
                            <div class="col-sm-10">
                                <p class="fontMS500 font-14" style="word-wrap: break-word;">
                                    Himno encomiástico [música] / por J. B. Alzedo ; letra del señor
                                    D. Patricio M. del Río. – [Santiago de Chile? : s.n., 1860?].
                                    1 partitura de director (6 p.) ; 35 cm.
                                    <span class="fontMS100">
                                    <br><br>
                                    Disponible en:
                                    <a href="http://hdl.handle.net/20.500.14428/80235" target="_blank" style="color: #000000;">http://hdl.handle.net/20.500.14428/80235</a>
                                    <br><br>
                                    Video:
                                    <a href="https://www.youtube.com/watch?v=HRma9XBZrV4" target="_blank" style="color: #000000;">https://www.youtube.com/watch?v=HRma9XBZrV4</a>
                                    <br>Interpretación de la Orquesta Sinfónica del Perú. [19 de agosto de
                                    2021].
                                    <br><br>
                                    Composición dedicada a Henry Meiggs, el contratista
                                    anglo-norteamericano que emprendió, en esos años, la
                                    construcción de los ferrocarriles que unirían la costa peruana con
                                    la zona andina.
                                    <br><br>
                                    </span>
                                </p>
                            </div>
                        </div>    
                    </div>
                    <div class="col-sm-6">
                        <div class="row" style="color: #000000">
                            <div class="col-sm-2" style="width: 10%">
                                <img src="/assets/images/micrositio/micrositio37/BERNARDO-ICONO-001.png">
                            </div>
                            <div class="col-sm-10">
                                <p class="fontMS500 font-14" style="word-wrap: break-word;">
                                    Canción orquestada con que el sentimiento patrio glorifica la gran
                                    victoria peruana de Ayacucho [música] / 
                                    <span class="fontMS100">por José Bernardo Alzedo.
                                        – Lima: [s.n.], 1924.
                                    <br><br>
                                    Disponible en:
                                    <a href="http://hdl.handle.net/20.500.14428/80237" target="_blank" style="color: #000000;">http://hdl.handle.net/20.500.14428/80237</a>
                                    <br><br>
                                    Video:
                                    <a href="https://www.youtube.com/watch?v=OVr0QSIEYuI&t=1728s" target="_blank" style="color: #000000;">https://www.youtube.com/watch?v=OVr0QSIEYuI&t=1728s</a>
                                    <br><br>
                                    Concierto de Gala de Música Patriótica de José Bernardo Alzedo.
                                    Cusco, 26 de agosto de 2014.
                                    <br><br>
                                    «Esta composición prueba que la contienda independentista no
                                    solo fue una lucha armada y política, sino también una batalla
                                    simbólica artística, en este caso, con una composición bella
                                    dedicada al triunfo a la Batalla de Ayacucho de 1824» (David
                                    Vargas T.).
                                    <br><br>
                                    </span>
                                </p>
                            </div>
                            <div class="col-sm-2" style="width: 10%">
                                <img src="/assets/images/micrositio/micrositio37/BERNARDO-ICONO-001.png">
                            </div>
                            <div class="col-sm-10">
                                <p class="fontMS500 font-14" style="word-wrap: break-word;">
                                    Al Sr. Gral. San Román [música] : himno ynaugural / 
                                    <span class="fontMS100">por J. B.
                                        Alzedo. -- [Lima? : s.n, 1828?].
                                    <br><br>
                                    Disponible en:
                                    <a href="http://hdl.handle.net/20.500.14428/80232" target="_blank" style="color: #000000;">http://hdl.handle.net/20.500.14428/80232</a>
                                    <br><br>
                                    Según Aurelio Tello, se trata de una composición que «tiene un
                                    tono laudatorio y pone en relieve la esperanza de conseguir la
                                    unión entre peruanos».
                                    <br><br>
                                    Video:
                                    <a href="https://www.youtube.com/watch?v=OVr0QSIEYuI&t=1728s" target="_blank" style="color: #000000;">https://www.youtube.com/watch?v=OVr0QSIEYuI&t=1728s</a>
                                    Concierto de Gala de Música Patriótica de José Bernardo Alzedo.
                                    Cusco, 26 de agosto de 2014.
                                    <br><br>
                                    </span>
                                </p>
                            </div>
                            <div class="col-sm-2" style="width: 10%">
                                <img src="/assets/images/micrositio/micrositio37/BERNARDO-ICONO-001.png">
                            </div>
                            <div class="col-sm-10">
                                <p class="fontMS500 font-14" style="word-wrap: break-word;">
                                    Himno a grande orquesta [música] /
                                    <span class="fontMS100">J. B. Alzedo. -- [Lima? : s.n,
                                        1831?].
                                    <br><br>
                                    Disponible en:
                                    <a href="http://hdl.handle.net/20.500.14428/80238" target="_blank" style="color: #000000;">http://hdl.handle.net/20.500.14428/80238</a>
                                    <br><br>
                                    Video:
                                    <a href="https://www.youtube.com/watch?v=OVr0QSIEYuI&t=1728s" target="_blank" style="color: #000000;">https://www.youtube.com/watch?v=OVr0QSIEYuI&t=1728s</a>
                                    <br><br>
                                    Concierto de Gala de Música Patriótica de José Bernardo Alzedo.
                                    Cusco, 26 de agosto de 2014.
                                    <br><br>
                                    «La denominación del “Himno a Grande Orquesta” que utiliza José
                                    Bernardo Alzedo, vista actualmente correspondería a lo que hoy
                                    llamamos una Orquesta de Cámara. (…) Creemos que el uso de dicho
                                    término sí tiene sentido para el caso peruano por dos motivos:
                                    primero, porque existían pocas escuelas de educación musical
                                    académica en el siglo XIX (…) y, segundo, había una intención de
                                    demostrar espectacularidad )a pesar que era una pequeña orquesta),
                                    al incluir instrumentos de percusión y un coro de solistas, sobre todo
                                    cuando se interpretaba la música con temas patrióticos» (David
                                    Vargas T.).
                                    <br><br>
                                    </span>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoNegro">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">

                    <div class="col-sm-3 bott">
                        <img class="LineSubsec_Izq bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio37/BERNARDO-LINEA-001.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel" style="margin-bottom: 2%;" width="100%"
                            src="/assets/images/micrositio/micrositio37/BERNARDO-LINEA-001.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 100%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal  font-40">
                            MÚSICOS DEL SIGLO XIX:<br>
                            BÚSQUEDA DE UNA<br>
                            NACIONALIDAD
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec_Izq bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio37/BERNARDO-LINEA-001.png">
                    </div>

                    <div class="c100">
                        <img class="lineCel" style="margin-top: 2%;" width="100%"
                            src="/assets/images/micrositio/micrositio37/BERNARDO-LINEA-001.png">
                    </div>

                    <p class="fontMS500 text-justify text-white font-22">
                        <br><br><br>
                        EN LOS INICIOS DEL SIGLO XIX, EL PERÚ RECIBIÓ MUCHA INFLUENCIA DE LA MÚSICA EUROPEA. SIN
                            EMBARGO, EXISTIERON MÚSICOS NACIONALES, UNO DE LOS CUALES FUE EL POETA MARIANO MELGAR,
                            QUIEN COMPUSO BREVES, AMOROSAS Y MELANCÓLICAS MELODÍAS.<br>
                            POR OTRO LADO, EL EMPLEO DE LA MÚSICA EN LAS IGLESIAS SE PROLONGÓ EN LA REPÚBLICA. ALGUNOS DE
                            LOS MÁS IMPORTANTES COMPOSITORES FUERON PEDRO TIRADO, SEUDÓNIMO DE PEDRO JIMÉNEZ DE ABRIL
                            (1780-1856) Y BONIFACIO LLAQUE.
                            <br><br>
                    </p>


                </div>

                <div class="row mt-5">
                    <div class="col mx-3 mb-3">
                        <br><br>
                        <a href="https://hdl.handle.net/20.500.14428/35986" target="_blank">
                            <img width="100%" src="/assets/images/micrositio/micrositio37/BERNARDO-036.png">
                        </a>
                        
                            <p class="text-center text-white font-12" style="background: #41295a; padding-left: 5%; padding-right: 5%" >
                                <br><br>
                                Retrato del músico italiano Claudio Rebagliati. Lima, Estudio
                                Courret Hermanos, 1885.<br>
                                    <br>
                                Disponible en: <a href="https://hdl.handle.net/20.500.14428/35986" target="_blank" style="color: #ffffff;" >
                                Biblioteca Digital<br>
                                    <br><br>
                                </a>
                            </p>
                    </div>
                    <div class="col-sm-6">
                        <p class=" text-justify text-white font-24" >
                            <br><br><br><br>
                            A MEDIADOS DE ESE SIGLO, SURGIÓ UNA CORRIENTE QUE
                            GENERÓ LA TENDENCIA NACIONALISTA. ASÍ, A PARTIR DE
                            1851, EN LIMA SE ESCUCHARON COMPOSICIONES CON
                            ALUSIONES A MOTIVOS POPULARES: «REGRESO A LIMA»,
                            «LOS ENCANTOS DEL PERÚ», «LAS GRACIAS DE UNA
                            TAPADA», ENTRE OTRAS.<br><br>
                            POSTERIORMENTE, LLEGÓ A LIMA EL VIOLINISTA, DIRECTOR
                            DE ORQUESTA Y COMPOSITOR ITALIANO CLAUDIO
                            REBAGLIATI (1843-1909), QUIEN RESTAURÓ, ARMONIZÓ Y
                            ORQUESTÓ LA ACTUAL VERSIÓN DEL HIMNO NACIONAL Y
                            CONTRIBUYÓ CON LA ACEPTACIÓN DE MELODÍAS Y RITMOS
                            POPULARES AL UTILIZARLOS COMO ELEMENTOS
                            FORMALES EN LA COMPOSICIÓN SINFÓNICA Y EN PIEZAS
                            PARA PIANO.<br>
                            <br>
                        </p>
                    </div>

                </div>

                <div class="row mt-5">
                    <div class="row mt-5">
                        <div class="col mx-2 mb-2">
                            <a href="https://hdl.handle.net/20.500.14428/65823" target="_blank">
                                <img width="100%" src="/assets/images/micrositio/micrositio37/BERNARDO-037.png">
                            </a>
                            
                                <p class="text-center text-white font-12" style="background: #41295a; padding-left: 5%; padding-right: 5%" >
                                    <br><br>
                                    Tirado Ximenes de Abril, Pedro, 1780-1856.
                                    Colección de jaravíes [música] : para canto y
                                    piano / por Don Pedro Tirao [sic] Ximenes de
                                    Abril, Mtro Mayor de Arequipa.<br>
                                        <br>
                                    Disponible en: <a href="https://hdl.handle.net/20.500.14428/65823" target="_blank" style="color: #ffffff;" >
                                    Biblioteca Digital<br>
                                        <br><br>
                                    </a>
                                </p>
                        </div>
                        <div class="col mx-2 mb-2">
                            <a href="http://hdl.handle.net/20.500.14428/80225" target="_blank" >
                                <img width="100%" src="/assets/images/micrositio/micrositio37/BERNARDO-038.png">
                            </a>
                            
                                <p class="text-center text-white font-12" style="background: #41295a; padding-left: 5%; padding-right: 5%" >
                                    <br><br>
                                    Rebagliati, Claudio, 1843-1909.
                                    La cocinera [música] : canción del siglo XIX
                                    cantada por la Estudiantina Limeña / por
                                    Claudio Rebagliati. -- [Lima : s.n., 1960?].<br>
                                        <br>
                                    Disponible en: <a href="http://hdl.handle.net/20.500.14428/80225" target="_blank" style="color: #ffffff;" >
                                    Biblioteca Digital<br>
                                        <br><br>
                                    </a>
                                </p>
                        </div>
                        <div class="col mx-2 mb-2">
                            <a href="https://hdl.handle.net/20.500.14428/65688" target="_blank" >
                                <img width="100%" src="/assets/images/micrositio/micrositio37/BERNARDO-039.png">
                            </a>
                            
                                <p class="text-center text-white font-12" style="background: #41295a; padding-left: 5%; padding-right: 5%" >
                                    <br><br>
                                    Rebagliati, Claudio, 1843-1909.
                                    Un 28 de julio [música] : rapsodia peruana...<br>
                                        <br>
                                    Disponible en: <a href="https://hdl.handle.net/20.500.14428/65688" target="_blank" style="color: #ffffff;" >
                                    Biblioteca Digital<br>
                                        <br><br><br><br>
                                    </a>
                                </p>
                        </div>
                        <div class="col mx-2 mb-2">
                            <a href="https://hdl.handle.net/20.500.14428/65796" target="_blank" >
                                <img width="100%" src="/assets/images/micrositio/micrositio37/BERNARDO-040.png">
                            </a>
                            
                                <p class="text-center text-white font-12" style="background: #41295a; padding-left: 5%; padding-right: 5%" >
                                    <br><br>
                                    Rebagliati, Claudio, 1843-1909.
                                    2 danzas habaneras para piano [música] / por
                                    C. Rebagliati. – Lima : E. Niemeyer &
                                    Inghirami, [1900?].<br>
                                        <br>
                                    Disponible en: <a href="https://hdl.handle.net/20.500.14428/65796" target="_blank" style="color: #ffffff;" >
                                    Biblioteca Digital<br>
                                        <br><br><br>
                                    </a>
                                </p>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <img src="/assets/images/micrositio/micrositio37/BERNARDO-LINEA-002.png" width="90%">
                
                <div class="row ">
                    <div class="col"></div>
                    <div class="col-sm-10">
                        <p class="text-center fontMS100 font-18">
                            <br>
                            <span>
                                <br><br>
                                «LA RIQUEZA CONCEPTUAL EN EL TRABAJO DE ALZEDO RADICA, PRINCIPALMENTE, EN QUE MEDIANTE SU TEORÍA PUDO UNIR
                                EL UNIVERSO SONORO LAICO DE SU ÉPOCA, CENTRADO EN EL TEATRO, CON LAS ASPIRACIONES PROPIAS DE LA MÚSICA
                                CATÓLICA DE SU TIEMPO. SIN EMBARGO, CON LOS AÑOS LAS REFORMAS A LA SONORIDAD LITÚRGICA IRÁN EN AUMENTO Y
                                EL CORPUS MUSICAL DE ALZEDO PASARÁ POR LA DRÁSTICA CENSURA DE LA IGLESIA CATÓLICA CHILENA HACIA EL CAMBIO
                                DE SIGLO».<br><br>
                                JOSÉ BERNARDO ALZEDO (1788-1878) O LA APOTEOSIS DE UN MÚSICO PARDO». VÍCTOR RONDÓN Y JOSÉ MANUEL IZQUIERDO KÖNIG. 2009
                                <br><br>
                            </span>
                        </p>
                    </div>
                    <div class="col"></div>
                </div>
                
                <img src="/assets/images/micrositio/micrositio37/BERNARDO-LINEA-003.png" class="reflejo"
                    width="90%" style="margin-left: 10%">
            </div>
        </div>
    </div>
</div>

<div class="fondoMorado">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div style="margin-bottom: 5%;" class="row">
                    <div class="col-sm-4">
                        <p style="line-height: 100%;margin-bottom: 0%;" class="fontMS500 text-white font-70">
                            Espacio <br> de diálogo
                        </p>
                    </div>
                    <div class="col-sm-8">
                        <img id="img_dialogo"
                            src="\assets\images\micrositio\micrositio34\FERNANDOG-LINEA-004.png">
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-4 p-3">
                        <p class="fontMS100 text-white font-24">
                            ¿La biografía de Alzedo podría
                            contribuir a la comprensión de la
                            historia cultural limeña y
                            santiaguina del siglo XIX? ¿Por
                            qué?

                            <br><br>
                            <img width="100%"
                                src="/assets/images/micrositio/micrositio34/FERNANDOG-LINEA-005.png">
                        </p>
                    </div>
                    <div class="col-sm-4 p-3">
                        <p class="fontMS100 text-white font-24">
                            ¿Cuáles fueron las principales
                            ideas de Alzedo sobre la música?

                            <br><br>
                            <img width="100%"
                                src="/assets/images/micrositio/micrositio34/FERNANDOG-LINEA-005.png">
                        </p>
                    </div>
                    <div class="col-sm-4 p-3">
                        <p class="fontMS100 text-white font-24">
                            ¿En qué medida las canciones
                            patrióticas de Alzedo
                            constituyeron un medio eficaz
                            para expresar su postura
                            ideológica y estética sobre la
                            sociedad peruana del siglo XIX?

                            <br><br>
                            <img width="100%"
                                src="/assets/images/micrositio/micrositio34/FERNANDOG-LINEA-005.png">
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-4">
                        <img class="LineSubsec_Izq" width="100%"
                            src="/assets/images/micrositio/micrositio14/ET04_MS013_ARG_LINEA1-recortada.png">
                    </div>
                    <div class="col-sm-4 text-center">
                        <p style="line-height: 160%;margin-bottom: 0%;"
                            class="fontMS700 text-center  font-40" style="color:#bb32ac;">
                            PARA SABER MÁS
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <img class="LineSubsec_Izq" width="100%"
                            src="/assets/images/micrositio/micrositio14/ET04_MS013_ARG_LINEA1-recortada.png">
                    </div>
                </div>
                <p class="fontMS100 text-left font-24">
                    <br><br>
                    Recomendamos algunas de las fuentes consultadas durante la investigación.
                    <br><br>
                </p>
                <div class="row">
                    <div class="col-sm-6">
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">Biblioteca Nacional del Perú (2015). </span>
                            <span class="fontMS100Italic text-gris" style="word-wrap: break-word;">Concierto de
                                gala de música patriótica de José Bernardo Alzedo.
                                Investigación de David Vargas Torreblanca. Lima: BNP.<br>
                            </span>

                        </p>
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">Izquierdo, J. M. (201?). </span>
                            <span class="fontMS100Italic text-gris" style="word-wrap: break-word;">José Bernardo Alzedo
                                (1788-1878): biografía de un músico peruano [en
                                línea]. [Santiago de Chile].</span><br><br>

                                Disponible en: 
                                <a href="https://alzedo.weebly.com/about.html" target="_blank" style="color: #000000;" >https://alzedo.weebly.com/about.html</a>
                                <br>
                        </p>
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">Rondón, V. (2014). </span>
                            <span class="fontMS100Italic text-gris" style="word-wrap: break-word;">Las canciones patrióticas de José
                                Bernardo Alzedo (1788-1878). Revista Musical
                                Chilena. Vol. 68, no. 222 (Santiago de Chile).<br><br></span>
                                Disponible en: <a href="https://www.scielo.cl/scielo.php?script=sci_arttext&pid=S0716-27902014000200002" target="_blank" style="color: #000000;">
                                    https://www.scielo.cl/scielo.php?script=sci_arttext&pid=S0716-27902014000200002<br>
                                        
                                    </a>
                        </p>
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">Raygada, C. (1954). </span>
                            <span class="fontMS100Italic text-gris" style="word-wrap: break-word;">Historia crítica del Himno
                                Nacional. Tomo II. Lima: Juan Mejía Baca y P. L.
                                Villanueva Editores. <br><br>
                            </span>
                        </p>
                    </div>
                    <div class="col-sm-6">
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">Iturriaga, E. y Estenssoro, J. C. (2007). </span>
                            <span class="fontMS100Italic text-gris" style="word-wrap: break-word;">Emancipación y
                                República; siglo XIX. En: La música en el Perú. Segunda
                                edición. Lima: Fondo Editorial Filarmonía, p.
                                [103]-124.
                            </span>
                        </p>
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">Pereyra Salas, E. (1978). </span>
                            <span class="fontMS100Italic text-gris" style="word-wrap: break-word;">Bibliografía musical de Chile
                                desde los orígenes a 1886. Santiago de Chile:
                                Ediciones de la Universidad de Chile.<br>
                            </span>

                        </p>
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">Sánchez Málaga, A. (2012). </span>
                            <span class="fontMS100Italic text-gris" style="word-wrap: break-word;">Nuestros otros ritmos y
                                sonidos: la música clásica en el Perú. Presentación,
                                Víctor Isla Rojas, Salomón Lerner Febres. Lima:
                                Fondo Editorial del Congreso del Perú. <br>
                            </span>
                        </p>
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">Tello Malpartida, A. (2018). </span>
                            <span class="fontMS100Italic text-gris" style="word-wrap: break-word;">José Bernardo Alcedo
                                (1788-1878): contextos que demarcan la vida y obra
                                del autor del Himno Nacional del Perú. En: Filosofía
                                elemental de la música / José Bernardo Alzedo. Lima:
                                Universidad Nacional de Música, p. [9]-28.<br>
                            </span>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>